import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=b2b560b0"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=b2b560b0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports